import { Record } from 'immutable';

const PropertyRecord = Record({
  id: 0,
  chain: null,
  brand: null,
  pid: null,
  name: null,
  address1: null,
  address2: null,
  address3: null,
  city: null,
  stateProvinceCode: null,
  countryCode: null,
  postalCode: null,
  phoneNr: null,
  faxNr: null,
  email: null,
  contactFirstNm: null,
  contactLastNm: null,
  subscriber: null,
  manuallyAdded: null
});

export class Property extends PropertyRecord {
  id: number;
  chain: string;
  brand: string;
  pid: string;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  stateProvinceCode: string;
  countryCode: string;
  postalCode: string;
  phoneNr: string;
  faxNr: string;
  email: string;
  contactFirstNm: string;
  contactLastNm: string;
  subscriber: boolean;
  manuallyAdded: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/property.ts